var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { DownOutlined, RightOutlined, SearchOutlined, TagsOutlined } from '@ant-design/icons';
import { useCallback, useMemo, useState } from 'react';
import { message } from 'antd';
import { packingInlineBadgeClassName, packingCountPillClassName } from '../../shared/badgeStyles';
var copyTextToClipboard = function (value) { return __awaiter(void 0, void 0, Promise, function () {
    var error_1, textArea, copied;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!value)
                    return [2 /*return*/, false];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                if (!((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText)) return [3 /*break*/, 3];
                return [4 /*yield*/, navigator.clipboard.writeText(value)];
            case 2:
                _b.sent();
                return [2 /*return*/, true];
            case 3: return [3 /*break*/, 5];
            case 4:
                error_1 = _b.sent();
                return [3 /*break*/, 5];
            case 5:
                try {
                    textArea = document.createElement('textarea');
                    textArea.value = value;
                    textArea.setAttribute('readonly', '');
                    textArea.style.position = 'fixed';
                    textArea.style.opacity = '0';
                    textArea.style.pointerEvents = 'none';
                    document.body.appendChild(textArea);
                    textArea.select();
                    copied = document.execCommand('copy');
                    document.body.removeChild(textArea);
                    return [2 /*return*/, copied];
                }
                catch (error) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/];
        }
    });
}); };
export var SourceItem = function (_a) {
    var _b, _c;
    var item = _a.item, _d = _a.isChild, isChild = _d === void 0 ? false : _d, _e = _a.showChildrenToggle, showChildrenToggle = _e === void 0 ? false : _e, _f = _a.isExpanded, isExpanded = _f === void 0 ? false : _f, onToggleChildren = _a.onToggleChildren, onCopyIdentifier = _a.onCopyIdentifier;
    var t = useTranslation().t;
    var fullyPacked = item.remaining === 0;
    return (_jsxs("div", __assign({ role: 'button', tabIndex: 0, onClick: function () { return onCopyIdentifier === null || onCopyIdentifier === void 0 ? void 0 : onCopyIdentifier(item); }, onKeyDown: function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onCopyIdentifier === null || onCopyIdentifier === void 0 ? void 0 : onCopyIdentifier(item);
            }
        }, className: "flex gap-3 rounded-lg border px-3 py-3 transition-colors cursor-pointer " + (fullyPacked ? 'bg-gray-50 border-gray-200 opacity-80' : 'bg-white border-gray-200') + " hover:border-blue-300 hover:bg-blue-50/40" }, { children: [_jsx("div", __assign({ className: "shrink-0 rounded-md bg-gray-100 flex items-center justify-center self-center " + (isChild ? 'h-10 w-10' : 'h-14 w-14') }, { children: _jsx(TagsOutlined, { className: 'text-gray-400 text-lg' }, void 0) }), void 0), _jsxs("div", __assign({ className: 'min-w-0 flex-1' }, { children: [_jsxs("div", __assign({ className: 'flex items-start justify-between gap-2' }, { children: [_jsxs("div", __assign({ className: 'flex min-w-0 items-center gap-1.5' }, { children: [_jsx("p", __assign({ className: "truncate text-sm font-semibold " + (fullyPacked ? 'line-through text-gray-500' : 'text-gray-800') }, { children: item.productName }), void 0), item.children && ((_b = item.children) === null || _b === void 0 ? void 0 : _b.length) > 0 && (_jsx("span", __assign({ className: packingInlineBadgeClassName + " uppercase tracking-wide bg-yellow-100 text-yellow-700" }, { children: t('KIT') }), void 0)), item.kind === 'kit' && (_jsx("span", __assign({ className: packingInlineBadgeClassName + " uppercase tracking-wide bg-blue-100 text-blue-700" }, { children: t('COMP') }), void 0)), item.isSerialized && (_jsx("span", __assign({ className: packingInlineBadgeClassName + " bg-indigo-100 text-indigo-700 uppercase tracking-wide" }, { children: t('S/N') }), void 0))] }), void 0), _jsxs("div", __assign({ className: 'flex shrink-0 items-center gap-1.5' }, { children: [showChildrenToggle && (_jsxs("button", __assign({ type: 'button', onClick: function (event) {
                                            event.stopPropagation();
                                            onToggleChildren === null || onToggleChildren === void 0 ? void 0 : onToggleChildren();
                                        }, className: 'inline-flex items-center rounded px-1.5 py-1 text-xs text-gray-500 hover:bg-gray-100 hover:text-gray-700', "aria-label": isExpanded ? t('Collapse') : t('Expand') }, { children: [isExpanded ? (_jsx(DownOutlined, { style: { fontSize: 10 } }, void 0)) : (_jsx(RightOutlined, { style: { fontSize: 10 } }, void 0)), _jsx("span", __assign({ className: 'ml-1 text-[10px] font-semibold' }, { children: ((_c = item.children) === null || _c === void 0 ? void 0 : _c.length) || 0 }), void 0)] }), void 0)), _jsxs("span", __assign({ className: packingCountPillClassName + " " + (fullyPacked ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-800') }, { children: ["x", item.quantity] }), void 0)] }), void 0)] }), void 0), _jsx("p", __assign({ className: 'mt-1 truncate text-xs text-gray-500' }, { children: item.productSku
                            ? "SKU: " + item.productSku
                            : item.productUpc
                                ? "UPC: " + item.productUpc
                                : "ID: " + item.productId }), void 0), _jsxs("div", __assign({ className: 'flex flex-row items-center justify-between' }, { children: [_jsxs("p", __assign({ className: 'text-xs text-gray-500' }, { children: [t('Packed'), ": ", item.packed, "/", item.quantity] }), void 0), _jsx("p", __assign({ className: "text-xs font-medium " + (fullyPacked ? 'text-green-600' : 'text-red-600') }, { children: fullyPacked ? t('Packed') : t('Rem') + ": " + item.remaining }), void 0)] }), void 0)] }), void 0)] }), void 0));
};
export var SourceItemList = function (_a) {
    var items = _a.items;
    var t = useTranslation().t;
    var _b = useState(''), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = useState(true), showPacked = _c[0], setShowPacked = _c[1];
    var _d = useState({}), expandedParents = _d[0], setExpandedParents = _d[1];
    var hasSearchTerm = searchTerm.trim().length > 0;
    var matchesSearch = useCallback(function (item, term) {
        var value = term.toLowerCase();
        return (item.productName.toLowerCase().includes(value) ||
            item.productId.toLowerCase().includes(value) ||
            item.productSku.toLowerCase().includes(value) ||
            item.productUpc.toLowerCase().includes(value));
    }, []);
    var filteredItems = useMemo(function () {
        var term = searchTerm.trim().toLowerCase();
        return items.reduce(function (acc, item) {
            var baseChildren = item.children || [];
            var visibleChildren = showPacked
                ? baseChildren
                : baseChildren.filter(function (child) { return child.remaining > 0; });
            var parentVisibleByStatus = showPacked || item.remaining > 0;
            if (!term) {
                if (!parentVisibleByStatus && visibleChildren.length === 0) {
                    return acc;
                }
                acc.push(__assign(__assign({}, item), { children: visibleChildren }));
                return acc;
            }
            var parentMatches = matchesSearch(item, term);
            var matchingChildren = visibleChildren.filter(function (child) { return matchesSearch(child, term); });
            if (!parentMatches && matchingChildren.length === 0) {
                return acc;
            }
            acc.push(__assign(__assign({}, item), { children: parentMatches ? visibleChildren : matchingChildren }));
            return acc;
        }, []);
    }, [items, searchTerm, showPacked, matchesSearch]);
    var toggleParent = useCallback(function (key) {
        setExpandedParents(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = !prev[key], _a)));
        });
    }, []);
    var getCopyValue = useCallback(function (item) {
        var sku = String(item.productSku || '').trim();
        if (sku)
            return { label: 'SKU', value: sku };
        var upc = String(item.productUpc || '').trim();
        if (upc)
            return { label: 'UPC', value: upc };
        var productId = String(item.productId || '').trim();
        if (productId)
            return { label: 'ID', value: productId };
        return null;
    }, []);
    var handleCopyIdentifier = useCallback(function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var copyData, copied;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    copyData = getCopyValue(item);
                    if (!copyData) {
                        message.error(t('No identifier available to copy'));
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, copyTextToClipboard(copyData.value)];
                case 1:
                    copied = _a.sent();
                    if (copied) {
                        message.success(t('Copied {{label}}: {{value}}', copyData));
                    }
                    else {
                        message.error(t('Unable to copy to clipboard'));
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [getCopyValue, t]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: 'border-b border-gray-200 p-3' }, { children: [_jsxs("div", __assign({ className: 'mb-2 flex items-center justify-between' }, { children: [_jsx("p", __assign({ className: 'text-xs font-semibold uppercase tracking-wide text-gray-500' }, { children: t('Items to Pack') }), void 0), _jsx("button", __assign({ type: 'button', className: "rounded px-2 py-1 text-xs font-semibold transition-colors " + (showPacked
                                    ? 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'), onClick: function () { return setShowPacked(function (prev) { return !prev; }); } }, { children: showPacked ? t('Hide Packed') : t('Show Packed') }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'relative' }, { children: [_jsx(SearchOutlined, { className: 'pointer-events-none absolute left-3 text-gray-400 self-center' }, void 0), _jsx("input", { type: 'text', value: searchTerm, onChange: function (event) { return setSearchTerm(event.target.value); }, placeholder: t('Search...'), className: 'w-full rounded-lg border border-gray-300 bg-gray-50 py-2 pl-9 pr-3 text-sm text-gray-700 focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none' }, void 0)] }), void 0)] }), void 0), _jsx("div", __assign({ className: 'flex flex-col gap-2 p-2' }, { children: filteredItems.length === 0 ? (_jsx("div", __assign({ className: 'text-center text-gray-400 text-sm py-6' }, { children: hasSearchTerm ? t('No source items matching your search term') : t('No source items') }), void 0)) : (filteredItems.map(function (item) {
                    var _a, _b;
                    var hasChildren = (((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
                    var isExpanded = hasSearchTerm || !!expandedParents[item.key];
                    return (_jsxs("div", __assign({ className: 'space-y-1.5' }, { children: [_jsx(SourceItem, { item: item, showChildrenToggle: hasChildren, isExpanded: isExpanded, onToggleChildren: function () { return toggleParent(item.key); }, onCopyIdentifier: handleCopyIdentifier }, void 0), hasChildren && isExpanded && (_jsx("div", __assign({ className: 'ml-5 space-y-1.5 border-l border-gray-200 pl-2' }, { children: (_b = item.children) === null || _b === void 0 ? void 0 : _b.map(function (child) { return (_jsx(SourceItem, { item: child, isChild: true, onCopyIdentifier: handleCopyIdentifier }, child.key)); }) }), void 0))] }), item.key));
                })) }), void 0)] }, void 0));
};
